import { render, staticRenderFns } from "./inspectproject.vue?vue&type=template&id=1dfc5bb5&"
import script from "./inspectproject.vue?vue&type=script&lang=js&"
export * from "./inspectproject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports